import { Alert, Button, Card, Col, Row } from 'antd';
import { Form, Input, RemoveButton } from 'components';
import { useIntl } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { AuthorSelect } from 'components/Select';

const { TextArea } = Input;

const AddAuthor = () => {
  const { formatMessage } = useIntl();

  return (
    <Form.List name={'authors'}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ name }) => {
            return (
              <Card
                className="gx-mb-3"
                key={name}
              >
                <Row className="gx-flex-row">
                  <Col>
                    <RemoveButton onClick={() => remove(name)} />
                  </Col>
                </Row>
                <Form.Item
                  name={[name, 'author']}
                  label={formatMessage({
                    id: 'article.process.content.selectAuthor',
                  })}
                  rules={[
                    {
                      required: true,
                      message: formatMessage({
                        id: 'appModule.requiredMessage',
                      }),
                    },
                  ]}
                  className="gx-mb-3"
                  required
                >
                  <AuthorSelect />
                </Form.Item>
                <Alert
                  type="info"
                  message={
                    <span>
                      Eklemek istediğiniz yazar adayı sistemde tanımlı değilse{' '}
                      <a
                        href="/yazar-islemleri/yazar-ekle"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        buraya tıklayarak
                      </a>{' '}
                      sisteme tanımlayabilir ve sonrasında bu sayfaya dönerek seçiminizi yapabilirsiniz.
                    </span>
                  }
                />
                <Form.Item
                  label={formatMessage({
                    id: 'article.process.content.authorReason',
                  })}
                  rules={[
                    {
                      min: 100,
                      message: formatMessage({
                        id: 'article.reasonLengthMessage',
                      }),
                    },
                  ]}
                  normalize={(value) => (value.trim() === '' ? undefined : value)}
                  name={[name, 'reason']}
                >
                  <TextArea
                    rows={4}
                    showCount
                  />
                </Form.Item>
              </Card>
            );
          })}
          <Card className="gx-mb-3">
            <Button
              type="dashed"
              onClick={() => add()}
              icon={<PlusOutlined />}
              className="gx-m-0"
              block
            >
              {formatMessage({ id: 'author.addAuthor' })}
            </Button>
          </Card>
        </>
      )}
    </Form.List>
  );
};

export default AddAuthor;
